import { Component, ElementRef, HostBinding, Input, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'dw-ui-floating-button',
  standalone: true,
  imports: [CommonModule, NgbTooltipModule],
  templateUrl: './floating-button.component.html',
  styleUrl: './floating-button.component.scss',
})
export class FloatingButtonComponent {
  @Input() icon: string;
  @Input() label: string;
  @Input() rounded = false;
  @HostBinding('style.--index') @Input() index: string;

  @HostBinding('style.--background-color') @Input() backgroundColor: string;
  @HostBinding('class.animated--slide-in') @Input() animated: boolean = true;

  @ViewChild('buttonElement') buttonElement!: ElementRef<HTMLButtonElement>;
}
